"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lodash = _interopRequireDefault(require("lodash.range"));
var _react = _interopRequireDefault(require("react"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _activitySearchParams = _interopRequireDefault(require("../constants/activitySearchParams"));
var _TenantContext = require("../context/TenantContext");
var _useEateriesQuery = _interopRequireDefault(require("../hooks/useEateriesQuery"));
var _useQueryParams = _interopRequireDefault(require("../hooks/useQueryParams"));
var _getRelevantTime = _interopRequireDefault(require("../utils/getRelevantTime"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _Carousel = _interopRequireWildcard(require("./designsystem/Carousel"));
var _CompanyTile = _interopRequireDefault(require("./designsystem/CompanyTile"));
var _GradientBackground = _interopRequireDefault(require("./designsystem/GradientBackground"));
var _Section = _interopRequireDefault(require("./designsystem/Section"));
var _Tile = require("./designsystem/Tile");
var _FavoriteIconButton = _interopRequireDefault(require("./FavoriteIconButton"));
var _useGetPageSlugByLocale = _interopRequireDefault(require("../hooks/useGetPageSlugByLocale"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const LIMIT = 12;
const ActivityEateries = ({
  coordinates
}) => {
  const {
    getPageSlugByLocale
  } = (0, _useGetPageSlugByLocale.default)();
  const companyPageSlug = getPageSlugByLocale('COMPANY');
  const [{
    startDate,
    endDate,
    placeId
  }] = (0, _useQueryParams.default)(_activitySearchParams.default);
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  // we basically use a month search whenever a day isn't specifically selected
  const dateVars = {
    startDate,
    endDate
  };
  const [ref, inView] = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true,
    rootMargin: '500px'
  });
  const {
    data,
    loading
  } = (0, _useEateriesQuery.default)({
    skip: !inView,
    variables: {
      limit: LIMIT,
      sortByDistanceTo: coordinates ? {
        lat: coordinates.lat,
        lon: coordinates.lon
      } : undefined,
      params: _objectSpread(_objectSpread({}, dateVars), {}, {
        placeId
      })
    }
  });
  const intl = (0, _reactIntl.useIntl)();
  const sizes = (0, _Tile.useTileImageSizes)();
  const showEateries = coordinates && data?.companies.hits && data.companies.hits.length > 0;
  return __jsx(_Section.default, {
    name: "eateries",
    ref: ref
  }, showEateries && __jsx(_react.default.Fragment, null, __jsx(_GradientBackground.default, null), __jsx(_ContentWrapper.default, null, __jsx(StyledCarousel, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "cvWdBT",
      defaultMessage: [{
        "type": 0,
        "value": "Eten en drinken in de buurt"
      }]
    }),
    continuous: true
  }, loading && (0, _lodash.default)(4).map(i => __jsx(_Carousel.CarouselChild, {
    key: i
  }, __jsx(_CompanyTile.default, {
    loading: true
  }))), !loading && data?.companies.hits?.map(hit => __jsx(_Carousel.CarouselChild, {
    key: hit.id
  }, __jsx(_CompanyTile.default, {
    icon: brandConfig.enableFavorites && __jsx(_FavoriteIconButton.default, {
      type: "company",
      id: hit.id
    }),
    videoUrl: hit.videoUrl,
    name: hit.name,
    place: hit.place,
    time: startDate && (0, _getRelevantTime.default)(intl, hit.normalOperatingHours, hit.specialOperatingHours),
    linkProps: {
      href: {
        pathname: `/${companyPageSlug}/${hit.slug}`
      },
      locale: intl.locale
    },
    sources: [{
      srcSet: hit.webpListImage?.transform?.srcSet ?? hit.webpMainImage?.transform?.srcSet,
      type: 'image/webp',
      sizes
    }, {
      srcSet: hit.listImage?.transform?.srcSet ?? hit.mainImage?.transform?.srcSet,
      type: 'image/jpeg',
      sizes
    }],
    fallback: {
      src: hit.listImage?.transform?.src ?? hit.mainImage?.transform?.src
    }
  })))))));
};
var _default = exports.default = ActivityEateries;
const StyledCarousel = (0, _styledComponents.default)(_Carousel.default).withConfig({
  displayName: "ActivityEateries__StyledCarousel",
  componentId: "yinsra-0"
})(["padding:var(--sectionPadding) 0;"]);